"use strict";

import initModulesInScope from "@elements/init-modules-in-scope";
import * as filterStore from './filter-store';
import fetch from '@elements/fetch';

let $filterFormResultElements = $('');
let $filterFormLoadingElements = $('');
let baseUrl = _config.filterStoreUrl;
let pendingRequest;

export function init () {
    $('.js-filter-form').each(function (index, form) {
        let $form = $(form);
        filterStore.setDefaultInputs(getInputStates($form));
    });

    filterStore.subscribe(function () {
        fetchResults();
    });

    let $pagination = $('.js-filter-form__paging');
    if ($pagination && $pagination.length) {
        filterStore.setDefaultInputs([{
            name: 'page',
            value: $pagination.find('.active > a').data('page')
        }]);
    }
}

export function initInScope($scope) {
    $scope.find('.js-filter-form').each(function (index, form) {
        let $form = $(form);

        $form.on('submit', function (evt) {
            let $form = $(this);

            evt.preventDefault();

            let inputState = [].concat(...$('.js-filter-form').toArray().map(x => getInputStates($(this))))
                .filter(x => x.name !== "isSubmitted")
                .filter(x => x.name !== "page");

            inputState.push({
                isFilter: false,
                isHidden: false,
                label: undefined,
                name: "isSubmitted",
                value: 1
            });
            filterStore.setInputs(inputState);
        });

        if($form.data('trigger')) {
            $form.on($form.data('trigger'), function () {
                filterStore.setInputs(getInputStates($form));
            });
        }

        filterStore.subscribe(function () {
            setFilterState($form, filterStore.getState());
        });
    });


    let $newfilterFormResultElements = $scope.find('.js-filter-form__result');
    $filterFormResultElements = $filterFormResultElements.add($newfilterFormResultElements);

    $filterFormLoadingElements = $filterFormLoadingElements.add($scope.find('.js-filter-form__loading'));

    $scope.find('.js-filter-form__paging').on('click', '[data-page]', function (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation(); // Otherwise this handler is called twice -> History back does not work correctly
        filterStore.setInputs([{
            name: 'page',
            value: $(this).data('page')
        }]);
    });

    $scope.find('.js-filter-form__group__reset').on('click', function (evt) {
        evt.preventDefault();

        $(this).closest('.js-filter-form__group').find('.js-filter-form__input').each(function () {
            let filterName = $(this).attr('name');

            for (var i = 0; i < filterStore.getState().length; i++) {
                if(filterStore.getState()[i].name === filterName) {
                    $.each(filterStore.getState()[i], function () {
                        filterStore.removeFilter(filterStore.getState()[i]);
                    });
                }
            }
        });
    });


    $scope.find('.js-filter-form__sort').on('click', function (evt) {
        evt.preventDefault();
        let $sortOrder = $('.js-filter-form__sort-value');
        let $sortValue = $(this).attr('data-sortorder');

        $sortOrder.val($sortValue);

        $(this).closest('.js-filter-form').submit();
    });

    $scope.find('#collapseName, #collapseLocation').on('shown.bs.collapse', function () {
        setTimeout(function(){
            $scope.find('.js-typeahead').focus();
        }, 250);
    });

    $('.js-filter-form__remove-visible-filters').on('click', function () {
        let url = window.location.toString();
        if (url.indexOf("?") > 0) {
            let clean_url = url.substring(0, url.indexOf("?"));
            window.location.href = clean_url;
        }
    });

}

function getInputStates ($form) {
    let inputsState = [];
    $form.find('.js-filter-form__input').each(function (index, input) {
        let newInputState = {
            name: $(input).attr('name'),
            label: $(input).data('label'),
            value: $(input).val()
        };

        if($(input).data('filter-label')) {
            newInputState.quickFilterText = $(input).data('filter-label');
        }

        if ($(input).is('[type=checkbox], [type=radio]')) {
            newInputState.isActive = $(input).is(':checked');
            newInputState.isCheckboxFilter = true;
        }

        if ($(input).attr('name').indexOf('[]') !== -1) {
            newInputState.isArray = true;
        }

        newInputState.isFilter = !$(input).hasClass('js-filter-form__input--no-filter');
        newInputState.isHidden = $(input).hasClass('js-filter-form__input--hidden-in-url');

        inputsState.push(newInputState);
    });

    return inputsState;
}

function setFilterState($form) {
    $form.find('.js-filter-form__input').each(function (index, input) {
        let $input = $(input);
        let filter;

        if ($input.is('[type=checkbox], [type=radio]')) {
            filter = filterStore.getFilter($input.attr('name'), $input.val());

            let $collapseParent = $input.closest('.collapse:not(.in)');

            if (filter && filter.isActive) {
                if (!$input.prop('checked')) {
                    $input.prop('checked', true);

                    if ($collapseParent && $collapseParent.length) {
                        $collapseParent.collapse('show');
                    }
                }
            } else {
                if ($input.prop('checked')) {
                    $input.prop('checked', false);
                }
            }
        } else {
            /*none radio & checkbox inputs*/
            filter = filterStore.getFilter(input.name);

            if (filter) {
                $input.val(filter.value);
            } else {
                $input.val(null);
            }
        }

        $input.trigger('value-change');
    });
}

let cache = [];
function fetchResults() {
    //console.log('fetchResults');
    if (pendingRequest) {
        pendingRequest.abort();
        //console.log('abort');
    }

    let url = baseUrl + (baseUrl.indexOf('?') < 0 ? '?': '&') + $.param(filterStore.getSerializedParams());

    let cacheResult = $.grep(cache, function (cacheEntry) { return cacheEntry.url === url});


    if ($filterFormResultElements.length) {
        let isResultInViewPort = $filterFormResultElements.toArray().map(element => {
            let rect = element.getBoundingClientRect();

            return (
                rect.top > 0
            );
        }).filter(x => !!x).length;

        if (!isResultInViewPort) {
            try {
                window.scroll({
                    top: $filterFormResultElements.eq(0).offset().top - 110,
                    behavior: 'smooth'
                });
            } catch (e) {
                window.scrollTo(0, $filterFormResultElements.eq(0).offset().top - 110)
            }
        }
    }


    if (cacheResult.length) {
        setResults(cacheResult[0].content);
    } else {
        $filterFormResultElements.addClass('is-loading');
        $filterFormLoadingElements.attr('hidden', false).removeClass('hidden');

        pendingRequest = fetch(url, {
            headers: {Ajax: 1}
        })
            .then(response => response.text())
            .then(function (data) {
                pendingRequest = null;

                setResults(data);

                cache.push({
                    url: url,
                    content: data
                });

                if (cache.length > 40) {
                    cache.shift();
                }
                $('.js-filter-dropdown__toggle').removeAttr('hidden');

                /* set results headline form hidden input val */
                let $removeElement = $('.js-filter-form__results-remove');
                let $resultsHeadline = $('.js-filter-form__results-headline');
                if($resultsHeadline.length) {
                    let $resultsHeadlineAjax = $('.js-filter-form__results-headline-txt').val();
                    $resultsHeadline.html($resultsHeadlineAjax);
                    $removeElement.remove();
                }

            })
    }
}

function setResults(result){
    $filterFormResultElements.removeClass('is-loading');
    $filterFormLoadingElements.attr('hidden', true).addClass('hidden');
    $filterFormResultElements.empty();
    let $newContent = $(result);
    $filterFormResultElements.append($newContent);
    initModulesInScope($newContent);

    /* set number of results form hidden input val */
    let $resultsNumber = $('.js-filter-form__results-number');
    if($resultsNumber.length) {
        let $resultsNumberAjax = $('.js-filter-form__results-ajax-number').val();
        console.log('value is', $resultsNumberAjax);
        $resultsNumber.html($resultsNumberAjax);
    }
}
